import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import LocalizedComponent from '../../components/localizedComponent';
import observeRootStore from '../../components/hoc/observeRootStore';
import FilterOptionInput from './filterOptionInput';

import './filter.scss';
import * as constants from '../../appConstants';

class Filter extends LocalizedComponent {
    render() {
        const { t } = this.props;
        return (
            <div className="filter-container">
                <h1>{t('filters.title')}</h1>
                <form>
                    <FilterOptionInput
                        optionValue={constants.FILTER_ALL}
                        label={t('filters.viewAll')}
                    />
                    <FilterOptionInput
                        optionValue={constants.FILTER_OFFICES}
                        label={t('filters.offices')}
                    />
                    <FilterOptionInput
                        optionValue={constants.FILTER_ENG_MAN}
                        label={t('filters.engMan')}
                    />
                    <FilterOptionInput
                        optionValue={constants.FILTER_RESEARCH_DEV}
                        label={t('filters.researchDev')}
                    />
                    <FilterOptionInput
                        optionValue={constants.FILTER_DEALERSHIPS}
                        label={t('filters.dealerships')}
                    />
                </form>
            </div>
        );
    }
}

Filter.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate()(observeRootStore(Filter));
